import axios from 'axios';
import i18n from '../i18n';

const apiClient = axios.create({
  baseURL: 'http://localhost:8080',
});

apiClient.interceptors.request.use((config) => {
  config.headers['Accept-Language'] = i18n.language || 'en';

  const token = localStorage.getItem('jwt_token');
  if (token && !config.headers['Authorization']) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }

  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const data = error.response?.data;
    if (data?.messageKey) {
      const { messageKey, message, ...interpolationArgs } = data;
      const translated = i18n.t(messageKey, {
        ns: 'errors',
        defaultValue: message || messageKey,
        ...interpolationArgs,
      });
      error.response.data.message = translated;
    }
    return Promise.reject(error);
  }
);

export default apiClient;
